import React, { useContext, useEffect, useState } from 'react'
import { Layout } from '~/components/Layout'
import { SEO } from '~/components/SEO'
import { injectIntl, Link, InjectedIntlProps } from 'gatsby-plugin-intl'
import Tags from '~/components/Tags'
import { Center, H1, View, ThemeContext, Text } from '~/pagui'
import Comments from './Comments'
import SocialMedia from './SocialMedia'
import { gql } from 'apollo-boost'
import { wpClient } from '../App'
import { css } from '@emotion/native'
import { Image } from 'react-native'
import { css as hcss } from '@emotion/css'
import { LG_SIZE } from '~/pagui/components/View'

export type CommentNode = {
  nodes: WpComment[]
}

export type WpComment = {
  id: string
  content: string
  date: string
  author: { node: { name: string } }
}

export type WpCategory = {
  databaseId: string
  name: string
}

export type WpCategoriesNode = {
  nodes: WpCategory[]
}

export type WpPost = {
  id: string
  date: string
  databaseId: number
  title: string
  content: string
  comments: CommentNode

  featuredImage: {
    node: { sourceUrl: string }
  }
  categories: WpCategoriesNode
}

type Props = {
  post: WpPost
} & InjectedIntlProps

const readableDate = (dateString: string) =>
  new Date(dateString).toLocaleDateString('fr-FR', {
    day: 'numeric',
    month: 'long',
    year: 'numeric',
  })

const blockText = hcss`

 h2 mark , h2 span{
  font-family : Matrice-Bold;
 }
 *{
  font-family : Montserrat-Regular;
  margin : 5px 0;
  line-height : 27px;
 }

 h2,h3,h4,h5,h6{
   font-family : Matrice-Bold;
   margin: 25px 0; 
 }
 a{
   color : #327AE7; 
   text-decoration : underline; 
 }
 figure{
  display : flex ; 
  justify-content : center; 
  margin : 40px 0; 
 }
  .has-light-green-cyan-color{
  color : #7bdcb5 ; 
 }
 .has-text-align-center{
   text-align : center;
 }
 .has-inline-color {
   background-color : yellow; 
 }

//  CAROUSEL

.has-carousel,.has-carousel-lrg{
  display : -webkit-box; 
}

.components-resizable-box__container{
  position: relative;
  user-select: auto;
  width: 100%;
  height: 400px;
  min-height: 0px;
  box-sizing: border-box;
  flex-shrink: 0;
 }

 .wp-block-coblocks-gallery-carousel{
  height: 100%;
  overflow: hidden;
  position: relative;
  width: 50%;
  margin: auto;
  @media(max-width : 1024px){
    width : 70%;
  }
  @media(max-width : 768px){
    width : 100%;
  }
 }
 .flickity-slider{
    height: 100%;
   position: absolute;
    width: 100%;

 }

 .flickity-button{
  align-items: center;
    border-radius: 100%;
    border : none; 
    width: 62px;   
    height: 62px;
    color: #fff;
    cursor: pointer;
    display: flex;
    margin: 0 1%;
    padding: 15px;
    position: absolute;
    right: 0;
    top: 50%;
    transition: 0.2s; 
    &:hover {
      background-color : rgba(255,255,255,0.25); 
    }
    z-index: 3;
}

.button_i{
  margin : auto;
  text-align : center; 
  font-size : 30px; 
}

.previous {
  left: 0;
  ::after {
    content  : "←"; 
    width : 32px; 
    height : 32px; 
    font-size : 40px;  
  }
}

.next{
right : 0; 
::after {
  content  : "→"; 
  width : 32px; 
  height : 32px; 
  font-size : 40px;  
}

}

.wp-block-coblocks-gallery-carousel .coblocks-gallery--figure{
  height: 100%;

}

.coblocks-gallery--item {
  transition:0.3s ease-out;
  width : 100%;
}
.coblocks-gallery--item img{
  flex: 1;
  height: 100%;
   object-fit: cover;
   width : 100%;
   margin-left : 3px; 
   margin-right : 3px;

}

// MEDIA & TEXT ----------------------
.wp-block-media-text{
  direction: ltr;
  display: grid;
  grid-template-columns: 50% 1fr;
  grid-template-rows: auto;
}

.alignwide{
 max-width: calc(1200px - 48px);
margin : auto; 
}

.wp-block-media-text .wp-block-media-text__media{
  grid-column: 1;
    grid-row: 1;
    margin: 0;
    
}

.wp-block-media-text .wp-block-media-text__content, .wp-block-media-text .wp-block-media-text__media {
  align-self : center; 
}

.wp-image-942 , .wp-image-1198 {
  max-width: unset;
    vertical-align: middle;
    width: 100%;
    height : auto; 
    object-fit : contain; 
}

.wp-block-media-text .wp-block-media-text__content{
  direction: ltr;
  grid-column: 2;
  grid-row: 1;
  padding: 0 8%;
  word-break: break-word;
}

.has-large-font-size{
  font-size: 2.25em;
  margin-top : 10px; 
  margin-bottom : 35px; 


}

 @media (max-width: 1024px) {
  h2{
    font-size : 20px ; 
}
}

@media (max-width: 600px) {
  .wp-block-media-text.is-stacked-on-mobile{
    grid-template-columns: 100%!important;
}

.wp-block-media-text.is-stacked-on-mobile .wp-block-media-text__content{
  grid-column: 1;
    grid-row: 2;
}
}
`

const blockArticle = hcss`
max-width : 1050px ;  
margin: 50px auto; 
@media (max-width: 1024px) {
  width: 90%;
}

`

const titleStyle = css({
  textAlign: 'center',
})

const imgStyle = css({
  width: '100%',
  height: '100%',
  borderRadius: 20,
  resizeMode: 'cover',
})

const blockImg = css({
  margin: 'auto',
  width: '100%',
  height: 500,
  borderRadius: 20,
  shadowColor: '#000',
  shadowOffset: {
    width: 18,
    height: 20,
  },
  shadowOpacity: 0.1,
  shadowRadius: 20,
  elevation: 1,
})
const logoStyle = css({
  width: 50,
  height: 50,
  resizeMode: 'contain',
})

const lineStyle = css({
  width: '100%',
  margin: 'auto',
  borderStyle: 'solid',
  borderWidth: 1,
  borderColor: 'black',
})

const News: React.FunctionComponent<Props> = ({
  intl: { formatMessage },
  post,
}) => {
  const [theme] = useContext(ThemeContext)
  const [comments, setComments] = useState<any>()
  let url = typeof location !== 'undefined' ? location.pathname : ''
  const idPost = encodeURIComponent(url.split('/')[2])
  const slider =
    typeof document !== 'undefined'
      ? document.querySelector('.wp-block-coblocks-gallery-carousel')
      : ''
  const sliderBlock: any =
    typeof document !== 'undefined'
      ? document.querySelector('.has-carousel')
      : ''
  const sliderBlockTransition: number = 0.3
  let activeSlide = 1
  const sliderContent: any =
    typeof document !== 'undefined'
      ? document.querySelectorAll('.coblocks-gallery--item')
      : ''

  slider
    ? slider.insertAdjacentHTML(
        'afterbegin',
        `<button class="flickity-button previous"></button> <button class="flickity-button next"></button>`
      )
    : null
  if (slider) {
    sliderBlock.style.transition =
      'transform ' + sliderBlockTransition + 's ease-out'
    sliderBlock.innerHTML = sliderContent[sliderContent.length - 1].outerHTML
    sliderContent.forEach((item: any) => {
      sliderBlock.innerHTML += item.outerHTML
    })
    sliderBlock.innerHTML += sliderContent[0].outerHTML

    const next: any =
      typeof document !== 'undefined' ? document.querySelector('.next') : ''
    const previous: any =
      typeof document !== 'undefined' ? document.querySelector('.previous') : ''

    dynamicSlider(activeSlide)

    next?.addEventListener('click', () => {
      activeSlide++
      dynamicSlider(activeSlide)
    })

    previous?.addEventListener('click', () => {
      activeSlide--
      dynamicSlider(activeSlide)
    })
  }

  function dynamicSlider(img_id: any) {
    if (activeSlide > sliderContent.length) {
      sliderBlock.style.transform = 'translateX(-' + img_id + '00%)'
      activeSlide = 1
      setTimeout(() => {
        sliderBlock.style.transition = 'transform 0s ease-out'
        sliderBlock.style.transform = 'translateX(-100%)'
        setTimeout(() => {
          sliderBlock.style.transition =
            'transform ' + sliderBlockTransition + 's ease-out'
        }, 20)
      }, sliderBlockTransition * 1000)
    } else if (activeSlide < 1) {
      sliderBlock.style.transform = 'translateX(-' + img_id + '00%)'
      activeSlide = sliderContent.length
      setTimeout(() => {
        sliderBlock.style.transition = 'transform 0s ease-out'
        sliderBlock.style.transform =
          'translateX(-' + sliderContent.length + '00%)'
        setTimeout(() => {
          sliderBlock.style.transition =
            'transform ' + sliderBlockTransition + 's ease-out'
        }, 20)
      }, sliderBlockTransition * 1000)
    } else {
      sliderBlock.style.transform = 'translateX(-' + img_id + '00%)'
    }
  }

  useEffect(() => {
    const process = async () => {
      const res = await wpClient.query<any>({
        query: wpQuery,
        variables: { id: post.databaseId },
      })

      setComments(res.data.post)
    }

    process()
  }, [])

  const estimatedTimeReading = (content: any) => {
    const htmlContent = content.replace(/<[^>]*>?/gm, '')
    const words = htmlContent.split(/\s+/).length

    return Math.ceil(words / 225)
  }
  return (
    <Layout>
      <SEO title={post.title} />
      <View
        style={{
          display: 'flex',
          flexDirection: 'row',
          marginTop: 60,
          padding: 20,
        }}
      >
        <Link
          to={`/ressources/${formatMessage({ id: 'urls-news' })}`}
          style={{
            height: 30,
            margin: 10,
            fontFamily: 'Montserrat-Regular',
          }}
        >
          Home
        </Link>
        <p style={{ margin: 10, fontFamily: 'Montserrat-Regular' }}> ᐳ </p>
        <p
          style={{
            fontWeight: 'bold',
            margin: 10,
            fontFamily: 'Montserrat-Regular',
          }}
        >
          {post.title}
        </p>
      </View>
      <SocialMedia id={idPost} />
      <div key={post.databaseId} className={blockArticle}>
        <Center>
          <>
            <View minShowSize={LG_SIZE}>
              <H1 style={[titleStyle, { fontSize: 30, lineHeight: 30 }]}>
                {post.title}
              </H1>
            </View>
            <View maxShowSize={LG_SIZE}>
              <H1 style={[titleStyle, { fontSize: 25, lineHeight: 25 }]}>
                {post.title}
              </H1>
            </View>
          </>
        </Center>
        <View style={[blockImg, theme.styles.mt5, theme.styles.mb3]}>
          <Image
            style={[imgStyle]}
            source={{
              uri: post.featuredImage ? post.featuredImage.node.sourceUrl : '',
            }}
          />
        </View>
        <View style={[theme.styles.flexRow, theme.styles.mb3]}>
          <Text>{readableDate(post.date)} - </Text>
          <Text>{estimatedTimeReading(post.content)} min de lecture</Text>
        </View>

        <Tags categories={post.categories as any} />
        <div
          className={blockText}
          dangerouslySetInnerHTML={{ __html: post.content }}
        />
        <View
          maxShowSize={LG_SIZE}
          style={[
            theme.styles.flexRowCenter,
            theme.styles.mt4,
            { padding: 30 },
          ]}
        >
          <a
            href={`https://www.facebook.com/sharer/sharer.php?u=https://www.pagily.io/news/${idPost}`}
            target="_blank"
          >
            <Image
              style={[logoStyle, theme.styles.m1]}
              source={{ uri: '/img/demo/facebook.svg' }}
            />
          </a>
          <a
            href={`https://twitter.com/intent/tweet?text=https://www.pagily.io/news/${idPost}`}
            target="_blank"
          >
            <Image
              style={[logoStyle, theme.styles.m1]}
              source={{ uri: '/img/demo/twitter.svg' }}
            />
          </a>
          <a
            href={` https://www.linkedin.com/sharing/share-offsite/?url=https://www.pagily.io/news/${idPost}`}
            target="_blank"
          >
            <Image
              style={[logoStyle, theme.styles.m1]}
              source={{ uri: '/img/demo/linkedIn.svg' }}
            />
          </a>
        </View>
        <View style={[lineStyle, theme.styles.mt5]}></View>

        {comments ? <Comments post={comments} /> : <></>}
      </div>
    </Layout>
  )
}

export default injectIntl(News)

const wpQuery = gql`
  query ($id: ID!) {
    post(id: $id, idType: DATABASE_ID) {
      id
      databaseId
      comments(first: 100) {
        nodes {
          id
          content
          date

          author {
            node {
              name
            }
          }
        }
      }
    }
  }
`
